import { useRouter } from 'next/router';
import { useEffect } from 'react';

const SHELL = ['/', '/pwa/install', '/services', '/services/new', '/quotes', '/quotes/new'];

/** Preload & nudge SW so it claims control promptly (Week 11 PWA tests). */
  export default function PrecacheRoutes() {
  const router = useRouter();
  useEffect(() => {
    if (typeof window === 'undefined') return;
    (async () => {
      try {
        // Only warm/cache when online to avoid fetch noise offline.
        if (navigator.onLine) {
          // Warm the app shell: prefetch chunks and fetch HTML so the SW can cache it.
          for (const p of SHELL) {
            try { router.prefetch(p).catch(() => {}); } catch {}
            try { await fetch(p, { cache: 'no-cache' }); } catch {}
          }
        }
        // If a SW is present, ask it to activate promptly; don't force a reload here.
        if ('serviceWorker' in navigator) {
          const reg = await navigator.serviceWorker.getRegistration();
          // Prefer messaging the waiting worker; fall back to active (no-op if already active).
          try { reg?.waiting?.postMessage?.('SKIP_WAITING'); } catch {}
          try { reg?.active?.postMessage?.('SKIP_WAITING'); } catch {}
          await navigator.serviceWorker.ready;
        }
      } catch {}
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
